import { z } from "zod";

export const paymentConflictsQuerySchema = z.object({
  appointmentId: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  offset: z.coerce.number().int().min(0).default(0),
});

export const paymentConflictSchema = z.object({
  id: z.string(),
  appointmentId: z.string(),
  appointmentDate: z.string(),
  timezone: z.string(),
  memberName: z.string().nullable(),
  customerName: z.string(),
  scheduleName: z.string().nullable(),
  reason: z.string(),
  amountMinor: z.number().int(),
  currency: z.string(),
  refundedMinor: z.number().int(),
  pendingRefundMinor: z.number().int(),
  outstandingMinor: z.number().int(),
  capturedAt: z.string(),
  stripePaymentIntentId: z.string(),
  stripeChargeId: z.string(),
  receiptUrl: z.string().nullable(),
  refunds: z.array(
    z.object({
      id: z.string(),
      stripeRefundId: z.string(),
      amountMinor: z.number().int(),
      status: z.enum([
        "PENDING",
        "SUCCEEDED",
        "FAILED",
        "CANCELED",
        "REVERSED",
      ]),
      occurredAt: z.string(),
    }),
  ),
});

export const paymentConflictsListSchema = z.object({
  rows: z.array(paymentConflictSchema),
  total: z.number().int(),
});

export type PaymentConflict = z.infer<typeof paymentConflictSchema>;
export type PaymentConflictsList = z.infer<typeof paymentConflictsListSchema>;
export type PaymentConflictsQuery = z.input<typeof paymentConflictsQuerySchema>;
